import React, { useState } from "react";
import { Link } from "react-router-dom";
// import IconSocalFurs from './SocalDate.jpg'
import IconSocalFurs from './Socalfurs.jpg'
import './AboutPage.css'

export default function AboutPage() {


  return (

       <div className = "about-us-main-container">
                  {/* <img className="homepage-main-icon" src={AfcImage} alt="Socalfurs.com" /> */}


             <div className = "about-us-container-1">
                      <header className = "about-us-header">What is <a href = "https://Socalfurs.com">SoCalFurs.com</a>?</header>
                      <p className = "about-us-p">
                        Established in 2001, <a href = "https://Socalfurs.com">SoCalFurs.com</a> is an “umbrella hub” website to find (and connect with) 
                        Furry fans living in Southern California. Our website and calendar is intended to 
                        serve as a resource for local events and groups centered around anthropomorphic, 
                        science fiction and fantasy culture to promote their meets and social media connections!

            
                      </p>
                      
                        <ul>
                          <li>
                              <p className = "about-us-p">
                                  We want to make it easy, for long-time furs and new furs alike, to 
                                  find what’s close to them! We feature events for All Ages and Adults Only
                              </p>
                          </li>
                          <li>
            
                              <p className = "about-us-p">
                                  All Events and Conventions* are highlighted and introduced through our 
                                  calendars (Google and Telegram).
                              </p>
                          </li>
                          <li>
            
                              <p className = "about-us-p">
                    
                              Our Website and subsequent Social Medias are under NEW MANAGEMENT! 
                              Please bear with us while we’re under construction! 
            
                                </p>
                          </li>
                        </ul>
                         <h2>
                          
                            SoCal Furs Social Media
                        </h2>
                        
                        <ul>
                          <li> <p className = "about-us-p">
                          <a href = "https://t.me/SoCalFursCalendar">SoCal Furs Telegram Channel</a>
                        </p>
                        </li>
                        <li>  <p className = "about-us-p">
                          <a href = "http://bit.ly/socalfurryevents">SoCal Furs Google Calendar</a>
                        </p>
                        </li>

                        <li>
                         <p className = "about-us-p">
                         
                              <a href = "https://twitter.com/socal_furs">Twitter/X</a>
                              <a href = "https://www.furaffinity.net/user/socalfurs">FurAffinity</a>
                            
                        </p>
                        
                        </li>
                        </ul>
                       
                        
              
                        
                        <p className = "about-us-p">
                          *All Events Are Owned And Operated Independently and Not Necessarily Affiliated With
                           One Another or SoCalFurs.com. We Are Just A Public Community Calendar.  
                           Please Observe Rules and Restrictions Per Each Individual Event
                          <ul>
                            <li>For Any Questions, Comments, or Concerns? Please E-mail our team!
                              <a href = "mailto:Admin@SoCalFurs.com"> Admin@SoCalFurs.com</a>
                            </li>
            
                          </ul>
                        </p>
            
                         <h2>Grovel's News Network</h2>
                        <p>SoCalFurs.com is Affliated with Grovel's News Network and <a href = "https://t.me/NorCalFursCalendar">The NorCalFurs Calendar </a>
                          Visit <a href = "https://t.me/GrovelReports">https://t.me/GrovelReports</a> for California Furry Fandom News and Alerts! 
                        </p>
                    </div>

            <div className = "about-us-space"></div>
            <div className = "about-us-image-container">
              <img className = "about-us-img" src = {IconSocalFurs}></img>
            </div>
    
                      
        </div>

         
  );
}
